import './bootstrap';
import '../css/app.css';
import Alpine from 'alpinejs';
// import './phone.js';
// import './address.js'; 
// import './note.js';
// import './websocket';
import NotificationPoller from './notifications.js';

if (window.Laravel && window.Laravel.userRoleId !== null && window.Laravel.userRoleId <= 3) {
    new NotificationPoller('/notifications');
}

import.meta.glob([
    '../images/**'
]);

import $ from 'jquery';
window.$ = window.jQuery = $;

// Global — accessible by Alpine components
function setDarkClass() {
    const isDark = localStorage.theme === 'dark' || (!('theme' in localStorage) && window.matchMedia('(prefers-color-scheme: dark)').matches);

    if (isDark) {
        document.documentElement.classList.add('dark');
        document.querySelectorAll('input').forEach(input => input.style.colorScheme = 'dark');
    } else {
        document.documentElement.classList.remove('dark');
        document.querySelectorAll('input').forEach(input => input.style.colorScheme = 'light');
    }
}
window.setDarkClass = setDarkClass;

document.addEventListener('DOMContentLoaded', function () {
    setDarkClass();
    window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', setDarkClass);
});

window.openEditBookingTab = function(url) {
    console.log("Opening URL:", url);
    var newTab = window.open(url, '_blank');

    if (newTab) {
        newTab.focus();
    } else {
        alert('Please allow popups for this website to edit the booking.');
    }
};

jQuery(document).ready(function($) {
    let isDirty = false;

    $('#update-form input, #update-form forms.textarea, #update-form select').on('change keyup input', function() {
        isDirty = true;
        $('#success-message').fadeOut();
    });

    $('#update-form').on('submit', function() {
        isDirty = false;
    });

    window.onbeforeunload = function() {
        if (isDirty) {
            return 'You have unsaved changes. Are you sure you want to leave?';
        }
    };
});

window.toastManager = function() {
    return {
        toasts: [],
        add(message, type = 'info') {
            const id = Date.now() + Math.random();
            const toast = { id, message, type, show: true };
            this.toasts.push(toast);
            setTimeout(() => {
                this.toasts = this.toasts.filter(t => t.id !== id);
            }, 15000);
        },
        init() {
            window.addEventListener('toast', e => {
                this.add(e.detail.message, e.detail.type);
            });
        }
    }
}

// Timeline tooltip functions
let currentTooltip = null;
let currentElement = null;
let tooltipTimeout = null;

window.showTooltip = function(element) {
    clearTimeout(tooltipTimeout);
    const tooltip = element.querySelector('.tooltip');
    if (tooltip && currentTooltip !== tooltip) {
        if (currentTooltip) {
            currentTooltip.classList.add('hidden');
            currentElement.appendChild(currentTooltip);
        }
        document.body.appendChild(tooltip);
        tooltip.classList.remove('hidden');
        tooltip.style.zIndex = '9999';
        currentTooltip = tooltip;
        currentElement = element;
        const event = window.event || {};
        if (event.clientX && event.clientY) {
            positionTooltip(event);
        }
    }
};

window.hideTooltip = function(element) {
    tooltipTimeout = setTimeout(() => {
        if (currentTooltip && currentElement === element) {
            currentTooltip.classList.add('hidden');
            element.appendChild(currentTooltip);
            currentTooltip = null;
            currentElement = null;
        }
    }, 100);
};

window.positionTooltip = function(event) {
    if (!currentTooltip) return;
    const offsetX = 30;
    const offsetY = 30;
    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;
    let tooltipX = event.clientX + offsetX;
    let tooltipY = event.clientY;
    const tooltipHeight = currentTooltip.offsetHeight;
    const tooltipWidth = currentTooltip.offsetWidth;
    if (tooltipX + tooltipWidth > viewportWidth) {
        tooltipX = event.clientX - tooltipWidth - offsetX;
        if (tooltipX < 0) tooltipX = 10;
    }
    if (tooltipY - tooltipHeight < 20) {
        tooltipY = event.clientY + offsetY;
    } else {
        tooltipY = event.clientY - tooltipHeight - offsetY;
    }
    if (tooltipY + tooltipHeight > viewportHeight) {
        tooltipY = viewportHeight - tooltipHeight - 10;
    }
    currentTooltip.style.position = 'fixed';
    currentTooltip.style.left = `${tooltipX}px`;
    currentTooltip.style.top = `${tooltipY}px`;
};

let lastMouseX = 0;
let lastMouseY = 0;

document.addEventListener('mousemove', event => {
    lastMouseX = event.clientX;
    lastMouseY = event.clientY;
    if (currentTooltip) positionTooltip(event);
});

window.addEventListener('scroll', () => {
    if (currentTooltip) {
        positionTooltip({ clientX: lastMouseX, clientY: lastMouseY });
    }
}, true);